module.exports = __webpack_public_path__ + "img/share-bg-8.06a405e8.jpg";